import React from 'react';
import styles from './UserRestrictedPermission.module.css';
import userFailureIcon from '../../assets/images/userFailureLarge.svg';
import AIEduButton from '../../components/Button/AIEduButton';
import { useNavigate } from 'react-router-dom';
import { LOGIN_PATH } from '../../router/RouteConstants';
import { API } from '../../services';

const UserRestrictedPermission = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const message = searchParams.get('msg');
    const navigate = useNavigate();

    const handleSignout = async () => {
        await API.signOut();
        navigate(LOGIN_PATH, { replace: true });
    };
    return (
        <div className='justify-content-center align-items-center page-layout'>
            <img className={styles.error_img} src={userFailureIcon} />
            <div className={styles.user_permission_text}>{message}</div>
            <AIEduButton
                label='Go To Login'
                severity='secondary'
                className={styles.login_btn}
                onClick={handleSignout}
            />
        </div>
    );
};

export default UserRestrictedPermission;
